import React, { FC } from 'react';
import styled from 'styled-components';
import { Image, Layout, Space, Menu } from 'antd';
import Logo from '../../assets/images/logo.png';
import { MdOutlineDashboard } from 'react-icons/md';
import { SiAltiumdesigner } from 'react-icons/si'
import { FaFirstOrder } from 'react-icons/fa'

import {
  UserOutlined,
  PrinterOutlined,
  LogoutOutlined,
  WechatOutlined,
} from '@ant-design/icons';
import { NavLink, RouteComponentProps, useHistory, withRouter } from 'react-router-dom';
import { removeCookie, removeUserData, removeUserId } from '../../utils/utilsFunctions';

const { Sider } = Layout;

const LogoDiv = styled(Space)`
    padding: 1rem;
    display: flex;
    justify-content: center;
    align-items: center;
`


interface SProps extends RouteComponentProps {
  collapsed?: any;
  activeKey: string;
}

const Sider3D: FC<SProps> = ({ collapsed, activeKey }) => {
  const history = useHistory();
  const handleLogout = () => {
    removeCookie();
    removeUserId();
    removeUserData();
    window.location.search = '';
    window.location.pathname = '/signin';;
  }
  return (
    <>
      <Sider trigger={null} collapsible collapsed={collapsed}>
        <LogoDiv>
          <NavLink to='/'>
            <Image preview={false} src={Logo} alt="" />
          </NavLink>
        </LogoDiv>
        <Menu theme="dark" mode="inline" selectedKeys={[activeKey]}>
          <Menu.Item
            key="/dashboard"
            icon={<MdOutlineDashboard />}
            onClick={() => history.push("/admin/dashboard")}
          >
            Dashboard
          </Menu.Item>
          <Menu.Item
            key="/users"
            icon={<UserOutlined />}
            onClick={() => history.push("/admin/users")}
          >
            Users
          </Menu.Item>
          <Menu.Item
            key="/designs"
            icon={<SiAltiumdesigner />}
            onClick={() => history.push("/admin/designs")}
          >

            Designs
          </Menu.Item>
          <Menu.Item
            key="/printers"
            icon={<PrinterOutlined />}
            onClick={() => history.push("/admin/printers")}
          >
            Printers
          </Menu.Item>
          <Menu.Item
            key="/orders"
            icon={<FaFirstOrder />}
            onClick={() => history.push("/admin/orders")}
          >
            Orders
          </Menu.Item>
          <Menu.Item
            key="/inbox"
            icon={<WechatOutlined />}
            onClick={() => history.push("/admin/inbox")}
          >
            Inbox
          </Menu.Item>
          <Menu.Item
            key="/logout"
            icon={<LogoutOutlined />}
            onClick={handleLogout}
          >
            Logout
          </Menu.Item>
        </Menu>
      </Sider>
    </>
  )
}

export default withRouter(Sider3D);